module.exports = __webpack_public_path__ + "img/frame (240).bfe3bcb0.jpg";